import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Stack from '@mui/material/Stack';
import { FirstTimeHero } from './first-time/FirstTimeHero';
import HomeBase from './home-base/HomeBase';
import MobileQuickLinks from './MobileQuickLinks';
import useAppState from '../../../common/state/appState';
import HomePageExperience from './store/HomePageExperience';
import TransferStatus from './home-base/TransferStatus';
import UFTTransferStatus from '../UFTTransferStatus/UFTTransferStatus';
import { hasUftTransferStatusOverride } from '../../../dev-tools/UftTransferStatus';
import UftYouLookedAt from '../homebase-optimization-test/OptViewed/ViewedVehiclesCarousel/UftYouLookedAt';
import { KmxContainer } from '../../../components/KmxContainer';

const HeroContainer: React.FC = () => {
    const isLoading = useAppState((state) => state.isLoading);
    const experience = useAppState((state) => state.experience);
    const serveUFTContentEnabled = useAppState((state) => state.serveUFTContent);
    const shouldRenderUftTransferStatus = serveUFTContentEnabled || hasUftTransferStatusOverride();

    if (isLoading) {
        const styles = serveUFTContentEnabled ? {} : { minHeight: { xs: 394, sm: 480, md: 464 } };
        return (
            <Box sx={styles}>
                <Stack alignItems="center" justifyContent="center" sx={{ minHeight: 320 }}>
                    <CircularProgress color="secondary" size={64} />
                </Stack>
            </Box>
        );
    }

    return (
        <>
            {!serveUFTContentEnabled && <MobileQuickLinks />}
            {experience === HomePageExperience.FirstTimeVisitor && <FirstTimeHero />}
            {experience === HomePageExperience.ReturnVisitor && <HomeBase />}
            {experience === HomePageExperience.Transfer &&
                (shouldRenderUftTransferStatus ? (
                    <>
                        <UFTTransferStatus />
                        <KmxContainer maxWidth="xl" sx={{ mt: { xs: 3 + 1.25, sm: 6 } }}>
                            <UftYouLookedAt />
                        </KmxContainer>
                    </>
                ) : (
                    <TransferStatus />
                ))}
        </>
    );
};

export default HeroContainer;
